module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "统计维度"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择统计维度"
    },
    on: {
      "change": _vm.getDataList
    },
    model: {
      value: (_vm.dimension),
      callback: function($$v) {
        _vm.dimension = $$v
      },
      expression: "dimension"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "项目",
      "value": "project"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "点位",
      "value": "device"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "功能区"
    }
  }, [_c('el-select', {
    attrs: {
      "reserve-keyword": ""
    },
    model: {
      value: (_vm.filters.functionalArea),
      callback: function($$v) {
        _vm.$set(_vm.filters, "functionalArea", $$v)
      },
      expression: "filters.functionalArea"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.functionalAreaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "因子"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.filters.facKeyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "facKeyword", $$v)
      },
      expression: "filters.facKeyword"
    }
  }, _vm._l((_vm.factors), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.filters.datatype),
      callback: function($$v) {
        _vm.$set(_vm.filters, "datatype", $$v)
      },
      expression: "filters.datatype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "天",
      "value": "day"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "月",
      "value": "month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "季度",
      "value": "quarter"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "年",
      "value": "year"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": _vm.timeType,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.filters.time),
      callback: function($$v) {
        _vm.$set(_vm.filters, "time", $$v)
      },
      expression: "filters.time"
    }
  })], 1), _vm._v(" "), (_vm.filters.datatype == 'quarter') ? _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "reserve-keyword": ""
    },
    model: {
      value: (_vm.filters.quarter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "quarter", $$v)
      },
      expression: "filters.quarter"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": "第一季度"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "第二季度"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "第三季度"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": "第四季度"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "ResetButtonShow": "",
      "ExportButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.dataList,
      "highlight-current-row": "",
      "border": "",
      "height": _vm.formHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "排名",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "项目名称",
      "min-width": "120",
      "prop": "projectName"
    }
  }), _vm._v(" "), (_vm.dimension == 'device') ? _c('el-table-column', {
    attrs: {
      "label": "功能区名称",
      "min-width": "120",
      "prop": "functionalAreaName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dimension == 'device') ? _c('el-table-column', {
    attrs: {
      "label": "点位名称",
      "min-width": "120",
      "prop": "deviceName"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": _vm.chooseFac,
      "label": "数值（dB）",
      "min-width": "120",
      "sortable": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-ea5062b4"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/form/OrderNumQuery.vue
// module id = 1968
// module chunks = 1